import Dexie, { Table } from 'dexie';

export interface LegacyData {
    id?: number;
    legacy_id: string;
    data: string;
}

export class ZenputDexie extends Dexie {
    legacy_data!: Table<LegacyData>;

    constructor() {
        super('zenput');
        this.version(1).stores({
            legacy_data: '++id, legacy_id'
        });
    }
}

export const zenputDb = new ZenputDexie();

export const clearIndexedDb = async () => {
    await zenputDb.legacy_data.clear();
};
